<template>
  <UContainer class="max-w-7xl py-16">
    <h2 class="text-3xl md:text-4xl font-bold text-center text-[#01365A] mb-4">
      Conheça os nossos cursos
    </h2>
    <p class="text-center text-gray-600 mb-12">
      Acesse as categorias abaixo e escolha a formação desejada
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      <HomeGridCategoriasCardSkeleton v-if="!isMounted" v-for="(category, categoryKey) in categoriesTitlesSkeleton"
                                      :key="categoryKey" :category="category" />
      <HomeGridCategoriasCard v-else v-for="category in categories" :key="category?.id"
                              :name="category ? category?.name: ''" :imageurl="category?.imageurl" />
    </div>
  </UContainer>
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

const useCatalogo = useCatalogStore()

// Transformar categories numa propriedade computada para reagir à store
const categories = computed(() => {
  return useCatalogo.getAreas.flatMap((area: Area) => {
    if (area.categoryId) {
      return [useCatalogo.getCategoryById(area.categoryId)];
    }
    return [];
  });
})

const isMounted = ref<boolean>(false)

// Mantemos o onMounted APENAS para lidar com a hidratação (skeleton loading)
onMounted(() => {
  isMounted.value = true
})

const categoriesTitlesSkeleton: string[] = [
    "Desenvolvimento de Sistemas e TI",
    "Direitos Humanos e Justiça",
    "Diversidade e Minorias",
    "Educação",
    "Gestão e Negócios",
    "Idiomas",
    "Meio Ambiente",
    "Pesquisa Científica",
    "Pré-IFMG e Pré-ENEM",
    "STEAM",
    "Tecnologia e Produção",
    "Trabalho",
]
</script>
